module.exports = __webpack_public_path__ + "img/completion3.eafea658.svg";